<template>
  <div class="publicservice">
    <div class="publicinfo">
      <div class="itemtop">
        <h3>公共服务</h3>
        <!-- <router-link :to="`/news/views/${plateId}`">更多</router-link> -->
      </div>
      <ul class="itembottom">
        <li @click="$wopen('http://cc.sacinfo.org.cn/')">
          <img src="/static/img/icon_yunketang.png" width="39" height="35" />
          <span>标准云课堂</span>
        </li>
        <li @click="$wopen('https://openstd.samr.gov.cn/bzgk/gb/')">
          <img src="/static/img/icon_2.png" width="39" height="35" />
          <span>国家标准公开</span>
        </li>
        <router-link :to="$QueryPath" tag="li">
          <img src="/static/img/icon_3.png" width="39" height="35" />
          <span>证书查询</span>
        </router-link>
        <router-link to="/message" tag="li">
          <img src="/static/img/icon_4.png" width="39" height="35" />
          <span>留言咨询</span>
        </router-link>
        <li @click="$wopen('https://gkml.samr.gov.cn/index.html?gkml=gkzd/')">
          <img src="/static/img/icon_5.png" width="39" height="35" />
          <span>公开制度</span>
        </li>
        <li @click="$wopen('https://std.samr.gov.cn/coordination')">
          <img src="/static/img/icon_xitong.png" width="39" height="35" />
          <span>标准化业务协同系统</span>
        </li>
      </ul>
    </div>
    <div class="serviceinfo">
      <div class="item" v-for="ad in imgAd" :key="ad.id">
        <img :src="`${IP_TEST}/uploads/${ad.picsrc}`" width="579" height="138" alt=""
          @click="ad.url&&$wopen(ad.url)" />
      </div>
    </div>
  </div>
</template>

<script>
import { getAd } from '@/request/get'
import { IP_TEST, AD_POSITION,PUBLIC_SERVICE } from '@/config'
export default {
  name: "PublicService",
  components: {
  },
  data() {
    return {
      IP_TEST: IP_TEST,
      imgAd: [],
      PUBLIC_SERVICE: PUBLIC_SERVICE
    }
  },
  computed: {
    plateId() {
      let { plates } = this.$store.state;
      let arrs = plates.filter(item => item.name == this.PUBLIC_SERVICE)
      return arrs.length === 0 ? "未配置" : arrs[0].uuid;
    }
  },
  mounted() {
    this.getAd();
  },
  methods: {
    async getAd() {
      let result = await getAd();
      this.imgAd = result.data && result.data.filter(item => item.position == AD_POSITION);
      console.log(this.imgAd);
    }
  }
};
</script>
<style scoped>
.publicservice{
  position: relative;
  width: 1200px;
  height: 452px;
  display: flex;
  justify-content: space-between;
}
.publicservice>.publicinfo,.publicservice>.serviceinfo{
  width: 579px;
  height: 452px;
}
.publicservice>.publicinfo>.itemtop{
  width: 568px;
  height: 55px;
  padding-left: 11px;
  background: #F7F7F8 url(/static/img/icon_gonggonfuuw.png) no-repeat;
  background-size: 192px 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.publicservice>.publicinfo>.itemtop>h3{
  width: 192px;
  height: 55px;
  padding-left: 39px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 55px;
  background: url(/static/img/publicservice.png) no-repeat left center;
  background-size: 23px 26px;
}
.publicservice>.publicinfo>.itemtop>a {
  width: 32px;
  height: 55px;
  padding: 32px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1759A1;
  line-height: 55px;
  background: url(/static/img/gengduo.png) no-repeat center right;
  background-size: 24px 13px;
}
.publicservice>.publicinfo>.itemtop>a{
  cursor: pointer;
}
.publicservice>.publicinfo>.itembottom{
  width: 579px;
  height: 360px;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.publicservice>.publicinfo>.itembottom>li {
  margin-top: 19px;
  width: 278px;
  height: 106px;
  border: 2px solid rgba(23, 89, 161,.4);
  /* opacity: 0.4; */
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.publicservice>.publicinfo>.itembottom>li:hover{
  border: 2px solid rgba(23, 89, 161, 1);
  cursor: pointer;
}
.publicservice>.publicinfo>.itembottom>li>span{
  height: 52px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1759A1;
  line-height: 52px;
}
.publicservice>.serviceinfo{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.publicservice>.serviceinfo>.item{
  width: 579px;
  height: 138px;
}
.publicservice>.serviceinfo>.item:hover{
  cursor: pointer;
}
</style>
